import React, { useState, useRef } from 'react'
import { Box, SvgIcon, Typography, Tooltip, IconButton } from '@material-ui/core'
import { ReactComponent as ClockOrder } from 'assets/icons/clock-order.svg'
import { transparentize } from 'polished'
import { dashboardCalculateTime } from 'utils'
import { MenuPopover } from 'shared'
import { MdHelpOutline } from 'react-icons/md'

import { useStyles } from './styles'
import { BiTimer, BiRefresh, BiPause } from 'react-icons/bi'

interface ICardInfo {
  title: string
  timeData: number
  isLiquidTime: boolean
  iconType?: 'cycle' | 'gross' | 'liquid' | 'idle'
  showAsSeconds?: boolean
  helpText?: string
}

export const CardInfo = (props: ICardInfo) => {
  const classes = useStyles()
  const { timeData, title, iconType, showAsSeconds, helpText } = props
  const [helpOpen, setHelpOpen] = useState(false)
  const helpRef = useRef(null)

  const formatTime = () => {
    if (showAsSeconds && timeData < 60) {
      // Exibe em segundos se for menor que 60 segundos
      return `${Math.floor(timeData)}s`
    }
    // Usa a formatação padrão HH:MM:SS
    return dashboardCalculateTime(timeData)
  }

  const time = formatTime()

  const renderIcon = () => {
    switch (iconType) {
      case 'cycle':
        return (
          <BiRefresh
            style={{
              fontSize: '2rem',
              color: transparentize(0.7, '#6ACFD8'),
              width: '30px',
              height: '30px',
            }}
          />
        )
      case 'liquid':
        return (
          <SvgIcon
            component={BiTimer}
            viewBox="0 0 25 25"
            style={{
              fontSize: '2rem',
              color: transparentize(0.7, '#6ACFD8'),
              width: '35',
              height: '35',
            }}
          />
        )
      case 'idle':
        return (
          <BiPause
            style={{
              fontSize: '2rem',
              color: transparentize(0.7, '#6ACFD8'),
              width: '30px',
              height: '30px',
            }}
          />
        )
      default:
        // 'gross' ou undefined
        return (
          <SvgIcon
            component={ClockOrder}
            viewBox="0 0 35 35"
            style={{
              fontSize: '2rem',
              color: transparentize(0.7, '#6ACFD8'),
              width: '30px',
              height: '30px',
            }}
          />
        )
    }
  }

  const toggleHelp = (e: React.MouseEvent) => {
    e.stopPropagation()
    setHelpOpen(state => !state)
  }

  return (
    <Box className={classes.root} style={{ position: 'relative' }}>
      <span className={classes.containerIcon}>{renderIcon()}</span>

      <Box style={{ flex: 1 }}>
        <Typography variant="subtitle1" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="subtitle2" className={classes.subtitle}>
          {time}
        </Typography>
      </Box>

      {helpText && (
        <IconButton
          ref={helpRef}
          onClick={toggleHelp}
          size="medium"
          style={{
            position: 'absolute',
            top: '6px',
            right: '6px',
            padding: '6px',
            minWidth: 'auto',
            width: '32px',
            height: '32px'
          }}
        >
          <MdHelpOutline
            size={18}
            color={transparentize(0.4, '#FF9800')}
          />
        </IconButton>
      )}

      {helpText && (
        <MenuPopover
          open={helpOpen}
          onClose={() => setHelpOpen(false)}
          anchorEl={helpRef.current}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Box style={{ padding: '12px 16px', maxWidth: '300px' }}>
            <Typography variant="body2" style={{ lineHeight: 1.4 }}>
              {helpText}
            </Typography>
          </Box>
        </MenuPopover>
      )}
    </Box>
  )
}
